import { exportBookmarks, importBookmarks, getBookmarks } from '@services/indexeddb'
import { pinOne, unpinOne, pinAll, unpinAll } from '@services/pinning'
import { useEffect, useState } from 'react'

export default function Bookmarks({ lang }: { lang: string }) {
  const [items, setItems] = useState<any[]>([])
  useEffect(() => { getBookmarks().then(setItems) }, [])
  return (
    <div className="flex flex-col gap-5">
      <div className="flex gap-3 flex-wrap">
        <button className="px-5 py-2.5 bg-primary text-white text-sm font-bold rounded-xl shadow-md hover:bg-primary/90 transition-all" onClick={async () => {
          const data = await exportBookmarks()
          const blob = new Blob([JSON.stringify(data)], { type: 'application/json' })
          const url = URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = 'bookmarks.json'
          a.click()
          URL.revokeObjectURL(url)
        }}>Export</button>
        <label className="px-5 py-2.5 bg-surface-container-high text-on-surface text-sm font-bold rounded-xl shadow-sm hover:bg-surface-container-highest transition-all cursor-pointer">
          Import
          <input type="file" className="hidden" accept="application/json" onChange={async e => {
            const f = e.target.files?.[0]
            if (!f) return
            const text = await f.text()
            const data = JSON.parse(text)
            await importBookmarks(data)
            setItems(await getBookmarks())
          }} />
        </label>
        <button className="px-5 py-2.5 border-2 border-outline-variant/30 text-on-surface text-sm font-bold rounded-xl hover:bg-surface-container-low transition-all" onClick={async () => { await pinAll(lang); setItems(await getBookmarks()) }}>Pin All</button>
        <button className="px-5 py-2.5 border-2 border-outline-variant/30 text-error text-sm font-bold rounded-xl hover:bg-error-container/20 transition-all" onClick={async () => { await unpinAll(); setItems(await getBookmarks()) }}>Unpin All</button>
      </div>
      <div className="space-y-3">
        {items.map(b => (
          <div key={b.id} className="flex flex-col md:flex-row md:items-center justify-between p-4 bg-surface rounded-2xl border border-outline-variant/20 shadow-sm gap-4">
            <div className="flex flex-col">
               <span className="font-bold text-on-surface text-lg">{b.name}</span>
               <span className={`text-xs uppercase tracking-wider font-bold mt-1 ${b.pinStatus === 'pinned' ? 'text-primary' : 'text-on-surface-variant'}`}>{b.pinStatus || 'not_pinned'}</span>
            </div>
            <div className="flex gap-2 self-start md:self-auto">
               <button className="text-xs px-4 py-2 bg-surface-container-high font-bold rounded-xl hover:bg-surface-container-highest transition-all" onClick={async () => { await pinOne(b.id, b.name, lang); setItems(await getBookmarks()) }}>Pin</button>
               <button className="text-xs px-4 py-2 border-2 border-error/20 text-error font-bold rounded-xl hover:bg-error-container/30 transition-all" onClick={async () => { await unpinOne(b.id); setItems(await getBookmarks()) }}>Unpin</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}